import { bootstrapApplication } from '@angular/platform-browser';
import { registerLocaleData } from '@angular/common';
import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';
import localeFr from '@angular/common/locales/fr';
import localeAr from '@angular/common/locales/ar';
import { addIcons } from 'ionicons';
import * as icons from 'ionicons/icons';
import * as Sentry from '@sentry/angular';
import { environment } from './environments/environment';
import { ModuleRegistry, AllCommunityModule } from 'ag-grid-community';

// Pre‑register every single Ionic icon globally
addIcons(icons);


ModuleRegistry.registerModules([AllCommunityModule]);

// Register Angular locale data for French and Arabic
registerLocaleData(localeFr, 'fr');
registerLocaleData(localeAr, 'ar');

// PII scrubbing helpers

/**
 * Recursively redact sensitive values from any object (headers, request bodies, etc.)
 * so that no plain‑text secrets, API keys, or tokens are sent to Sentry.
 */
function scrubSensitiveData(obj: any): void {
  if (!obj || typeof obj !== 'object') return;

  Object.keys(obj).forEach(key => {
    const value = obj[key];
    if (typeof value === 'string') {
      // Redact known sensitive field names (case‑insensitive)
      if (/^(x-?api-?key|authorization|cookie|set-cookie|password|secret|token|session|auth)$/i.test(key)) {
        obj[key] = '[Filtered]';
      }
    } else if (key === 'headers' && typeof value === 'object') {
      // Special handling for headers objects
      Object.keys(value).forEach(headerName => {
        if (/^(x-?api-?key|authorization|cookie|set-cookie|password|secret|token|session|auth)$/i.test(headerName)) {
          value[headerName] = '[Filtered]';
        }
      });
    } else if (typeof value === 'object') {
      scrubSensitiveData(value);
    }
  });
}

/**
 * Strip the native Capacitor API key and any other PII from breadcrumbs
 * (network requests, console logs, etc.).
 */
function sanitizeBreadcrumb(breadcrumb: any): void {
  if (breadcrumb.data) {
    scrubSensitiveData(breadcrumb.data);
  }
}

/**
 * Strip sensitive data from the main error event payload before it is sent.
 */
function sanitizeEvent(event: any): void {
  if (event.request) {
    scrubSensitiveData(event.request);
  }
}

// ═══════════════════════════════════════════════════════════════
// INITIALISE SENTRY *BEFORE* BOOTSTRAP
// ═══════════════════════════════════════════════════════════════
Sentry.init({
  dsn: 'https://23e1ebeacbe78a9e4015ed06be41e048@o4511712336805888.ingest.us.sentry.io/4511712358694912', 
  environment: environment.production ? 'production' : 'development',
  integrations: [
    Sentry.browserTracingIntegration(),
    // Optionally add angularRouterInstrumentation once you have Router
    // Sentry.angularRouterInstrumentation(),
  ],
  tracesSampleRate: 1.0,
  // Restrict trace propagation to backend API hosts (dev & prod)
  tracePropagationTargets: [
    /^http:\/\/localhost(:\d+)?/,
    /^https:\/\/api\.rtila\.ai/,
  ],
  // Session tracking is automatically enabled in the v8 SDK

  // PII scrubbing hooks
  beforeBreadcrumb(breadcrumb) {
    sanitizeBreadcrumb(breadcrumb);
    return breadcrumb;
  },
  beforeSend(event) {
    sanitizeEvent(event);
    return event;
  },
});

bootstrapApplication(AppComponent, appConfig);
